import React, { useState, useEffect } from 'react';
import { Col, Row, Input, Label } from 'reactstrap';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab'


// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';

//API Calls
const { apiListadoContratos } = require('../../../utils/APIs/APISResume')

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalGeneracionProrroga = (props) => {
    let todayDate = new Date(Date.now())
    const [tipo, setTipo] = useState(0)
    const [codEmpl, setCodEmpl] = useState(undefined)
    const [ok, setOk] = useState(true)

    const returnInputGerencia = () => {
        return (
            <Col lg='6' md='6' xs="12">
                <Autocomplete
                    required
                    margin="dense"
                    // options={props.userData.roles.includes('6') ? ['Todos', ...listaContratos] : listaContratos}
                    options={[{ value: 0, label: 'Menor a 30 días' }, { value: 1, label: 'Mayor a 30 días' }]}
                    key={`key_TipoDeContrato`}
                    id={`select_TipoDeContrato`}
                    onChange={(event, newValue) => {
                        setTipo(newValue.value)
                    }}
                    renderInput={(params) => (
                        <TextField {...params} label={'CONTRATO'} margin="normal" />
                    )}
                    getOptionLabel={(option) => option.label}
                    renderOption={(option) => (
                        <React.Fragment>
                            {option.label}
                        </React.Fragment>
                    )}
                />
            </Col>
        )
    }
    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                title={'Exportar Reporte'}
                buttonTitle={'Enviar'}
                // buttonLoading={codEmpl === undefined || codEmpl === 0 || codEmpl === null}
                enableOk={ok}
                onClick={() => props.action({ codEmpl, tipo })}
            // buttonLoading={cancelando}
            >
                <Row>
                    <Col lg='6' md='6' xs="12">
                        <TextField
                            required
                            key={`key_mail`}
                            id={`input_mail`}
                            fullWidth
                            label='Cédula'
                            margin="normal"
                            onChange={(e) => { setCodEmpl(e.target.value) }}
                        />
                    </Col>
                    {returnInputGerencia()}
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalGeneracionProrroga);